<script>
    import { popupMessage, showPopup, hidePopup } from '../stores';
    import { onMount } from 'svelte';
    import logo from '$lib/images/Latest Icons/Heatificate.png';


    let message;
    let visible;

    onMount(() => {
        const unsubscribeMessage = popupMessage.subscribe(value => {
            message = value;
        });

        const unsubscribeVisible = showPopup.subscribe(value => {
            visible = value;
        });

        return () => {
            unsubscribeMessage();
            unsubscribeVisible();
        };
    });

    function handleKeydown(event) {
        if (event.key === 'Escape') {
            hidePopup();
        }
    }
</script>

{#if visible}
    <div class="overlay" role="button" tabindex="0" on:click={hidePopup} on:keydown={handleKeydown}></div>
    <div class="popup" role="dialog" aria-modal="true">
        <div class="popup-header">
            <img src={logo} alt="Heat-ificate" class="logo">
            <h2>An Error Has Occurred</h2>
        </div>
        <p class="popup-message">{message}</p>
        <p>Please try again or get in touch via the contact page.</p>
        <button on:click={hidePopup}>Close</button>
    </div>
{/if}

<style>
    .overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        z-index: 999;
    }

    .popup {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: white;
        padding: 2rem;
        border-radius: 0.5rem;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
        z-index: 1000;
        text-align: center;
        max-width: 400px;
        width: 90%;
    }

    .popup-header {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 1rem;
    }

    .logo {
        width: 15%;
        margin-bottom: 1rem;
    }

    .popup-message {
        margin-bottom: 1rem;
        font-size: 1rem;
        color: #333;
    }

    .popup button {
        margin-top: 1rem;
        padding: 0.5rem 1rem;
        background: #007bff;
        color: white;
        border: none;
        border-radius: 0.25rem;
        cursor: pointer;
    }

    .popup button:hover {
        background: #0056b3;
    }
</style>